<template>
  <div class="mpn_mypack">
    <app-header />
    <mpn-page-title :title="pageTitle" />
    <main class="a-service-main">
      <div class="a-service-container">
        <div class="cont_section">
          <div class="cart_product-area">
            <div class="akl-toggle-wrap order-items-toggle cart_product-list">
              <!-- 수령방법 -->
              <receive-methods
                v-if="!!orderData.abo_info.defaultAddress.id"
                :abc-id="orderData.abc_cd"
                :delivery-address="orderData.abo_info.defaultAddress"
                :receive-method="orderData.cfm_kind"
                @store-delivery-info="storeDeliveryInfo"
                @update-receipt-info="storeReceiptInfo"
              />
              <!-- 결제수단 -->
              <payment-methods v-if="!!localAmwayPayMethods"
                :amway-pay-methods="localAmwayPayMethods"
                :promotion-info="orderData.appliedOrderPromotions"
                :can-installing="canInstalling"
                :cash-receipt="cashReceipt"
                @update-receipt-info="storeReceiptInfo"
                @update-cart-info="updateCartInfo"
              />
              <!-- 주문상품목록 -->
              <order-products
                v-for="(pack, packIndex) in orderedProductsData.orderedProducts"
                :key="packIndex"
                :products-info="{
                  products: pack,
                  packName: orderedProductsData.packNames[packIndex],
                }"
              />
              <p class="product_txt">
                더블엑스 주문 수량은 [골드, 실버, 그린 각 1정 씩 포함된 한
                세트]의 주문 수량입니다.
              </p>
            </div>
            <!-- 우측 영역 -->

            <div class="cart_product-floating js-uxeposfix">
              <div class="box_cart-option">
                <!-- 결제정보요약 -->
                <order-summary
                  :packs="packsSummary"
                  :total-payment-info="totalPaymentInfo"
                />

                <!-- 프로모션 -->
                <applied-promotions
                  :applied-order-promotions="orderData.appliedOrderPromotions"
                  :applied-product-promotions="
                    orderData.appliedProductPromotions
                  "
                />

                <!-- 약관.-->
                <order-terms
                  :is-toss-terms-required="isTossTermsRequired"
                  @open-popup="changeTermsPopup"
                />

                <!-- 결제버튼 -->
                <div class="btn_floating-group">
                  <span class="btn_box">
                    <button
                      type="button"
                      class="btn_square-a"
                      @click="onClickOrder"
                    >
                      <span class="txt_total-price">
                        총<strong class="txt_point-color">
                          {{ totalPaymentInfo.totalPrice }}</strong
                        >원
                      </span>
                      결제하기
                    </button>
                  </span>
                </div>

                <div
                  class="cart_insurance_area txt_insurance-title withTooltip"
                >
                  <span class="sstit"> 소비자피해보상보험 가입 안내 보기 </span>
                  <div
                    class="toolTip-wrapper toolTip-type02 type-mob-full"
                    :class="customerInsuranceToolTip ? 'open' : ''"
                  >
                    <button
                      type="button"
                      class="btn-tooltip"
                      @click="
                        customerInsuranceToolTip = !customerInsuranceToolTip
                      "
                    >
                      <span class="hidden">안내</span>
                    </button>
                    <div class="tipCont-wrapper">
                      <div
                        class="tooltip-content"
                        :style="
                          customerInsuranceToolTip
                            ? { display: 'block' }
                            : { display: 'none' }
                        "
                      >
                        <ul class="list-type5">
                          <li>
                            전자상거래등에서의 소비자보호에관한 법률에 따라
                            직접판매공제조합에 가입하여 고객님의 결제금액에 대해
                            안전거래를 보장하고 있습니다.
                          </li>
                        </ul>
                        <a
                          href="https://www.macco.or.kr/ko/cn/KOCNMC01.action"
                          target="blank"
                          class="bt-akl-white mini st2"
                        >
                          보험가입사실 확인
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="box_mobile-floating payment" style="display: none">
            <button
              type="button"
              class="btn_square-a btn_payment-type"
              @click="onClickOrder"
            >
              <span class="txt_total-price">
                총<strong class="txt_point-color">{{
                  totalPaymentInfo.totalPrice
                }}</strong
                >원
              </span>
              <span class="txt_point-payment">결제하기</span>
            </button>
          </div>
        </div>
      </div>
      <!-- E : 모바일 플로팅 -->
      <modal-alert ref="refAlert" />
    </main>
    <!-- E : main -->

    <app-footer />

    <popup-terms
      :display-modal="displayTermsPopup"
      :terms-id="displayTermsIndex"
      @close-terms="displayTermsPopup = false"
    />
  </div>
</template>

<script>
import { log, thousandSeparator } from "@/utils/common";
import orderApi from "@/apis/order";
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import ModalAlert from "@/components/global/ModalAlert";
import MpnPageTitle from "@/plugins/mpn-base-components/MpnPageTitle";
import ReceiveMethods from "@/views/order/main/components/Receive/ReceiveMethods";
import PaymentMethods from "@/views/order/main/components/Payment/PaymentMethods";
import OrderProducts from "@/views/order/main/components/Products/OrderProducts";
import { mapGetters, mapActions } from "vuex";
import orderHelpers from "@/utils/helpers/order";
import OrderSummary from "@/views/order/main/components/Summary/OrderSummary";
import AppliedPromotions from "@/views/order/main/components/Promotion/AppliedPromotions";
import OrderTerms from "@/views/order/main/components/Terms/OrderTerms";
import PopupTerms from "@/views/order/main/components/PopUpWrappers/PopupTerms";

import {
  NORMAL_PAYMENT_METHODS,
  PICKUP_METHODS,
  CASH_RECEIPT_REG_TYPE,
  DELIVERY_FEE_SKU,
  PACKAGE_WRAPPING_FEE_SKU,
  PAYMENT_METHODS,
  AMWAY_PAY_METHODS,
  BILLING_PAYMENT_MODE,
  QUICK_ACCOUNT_PAYMENT_TYPE,
} from "@/utils/constants";
import auth from "@/apis/auth";

export default {
  name: "Order",
  components: {
    OrderTerms,
    ModalAlert,
    AppFooter,
    AppHeader,
    MpnPageTitle,
    ReceiveMethods,
    PaymentMethods,
    OrderProducts,
    OrderSummary,
    AppliedPromotions,
    PopupTerms,
  },
  props: {
    orderInfo: {
      type: Object,
      required: false,
    },
    amwayPayMethods: {
      type: Object,
      required: false,
    },
    purchaseType: {
      type: String,
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      entireProducts: "product/productsAll",
      currentOrderMode: "order/currentOrderMode",
      currentReceiveMethod: "order/currentReceiveMethod",
      storedDeliveryInfo: "delivery/deliveryInfo",
      currentAmwayPayMethod: "order/currentAmwayPayMode",
      currentOtherPayMethod: "order/currentOtherPayMode",
      accountPassword: "account/password",
      creditCardInfo: "creditcard/creditCardPaymentInfo",
      accountPaymentInfo: "account/accountPaymentInfo",
      pickUpAboPhone: "pickup/pickUpAboPhone",
      ssoToken: "ssoToken",
      amwayPayAccountClientKey: "amwaypay/currentAmwayPayAccountClientKey",
      amwayPayCardClientKey: "amwaypay/currentAmwayPayCardClientKey",
      amwayPayAccountStoreId: "amwaypay/currentAmwayPayAccountStoreId",
      amwayPayCardStoreId: "amwaypay/currentAmwayPayCardStoreId",
      amwayPayAccount: "amwaypay/selectedAmwayPayAccount",
      amwayPayCard: "amwaypay/selectedAmwayPayCard",
      storedReceiptInfo: "receipt/getReceiptInfo",
      amwayPayInstallmentPlan: "amwaypay/amwayPayInstallmentPlan",
      allTerms: "terms/getAllTerms",
    }),

    // 토스 약관 사용 여부
    isTossTermsRequired() {
      if (this.currentOrderMode === PAYMENT_METHODS.AMWAY_PAY) {
        return true;
      } else if (this.currentOrderMode === PAYMENT_METHODS.NORMAL) {
        if (this.currentOtherPayMethod === NORMAL_PAYMENT_METHODS.TRANSFER) {
          return false;
        } else if (
          this.currentOtherPayMethod === NORMAL_PAYMENT_METHODS.CREDIT_CARD
        ) {
          return this.creditCardInfo.cardCompanyCode !== "C04";
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    // 묶음주문 여부
    isBundle() {
      return this.orderData.group && this.orderData.group === "Y";
    },
    // 전체 주문 가격
    prices() {
      return {
        price: this.orderData.total_price,
        pv: this.orderData.total_pv,
        bv: this.orderData.total_bv,
      };
    },
    // 할부 가능 여부
    canInstalling() {
      return this.prices.price >= 50000;
    },
    // 배송비
    deliveryFee() {
      let items = this.isBundle
        ? this.orderData.group_product_info[0].product_info.find(
            (item) => item.item_sku === DELIVERY_FEE_SKU
          )
        : this.orderData.product_info.find(
            (item) => item.item_sku === DELIVERY_FEE_SKU
          );

      let fee = items ? items.total_price : 0;
      this.$store.commit("delivery/updateDeliveryFee", fee);
      return fee;
    },
    // 포장비
    packagingFee() {
      if (this.isBundle) {
        let totalWrappingPrice = 0;

        this.orderData.group_product_info.forEach((product) => {
          let item = product.product_info.find(
            (n) => n.item_sku === PACKAGE_WRAPPING_FEE_SKU
          );
          if (item) {
            totalWrappingPrice += item.total_price;
          }
        });

        return totalWrappingPrice;
      } else {
        let item = this.orderData.product_info.find(
          (n) => n.item_sku === PACKAGE_WRAPPING_FEE_SKU
        );

        if (item) {
          return item.total_price;
        }

        return 0;
      }
    },
    orderedProductsData() {
      return {
        orderedProducts: !this.isBundle
          ? [
              orderHelpers.refineOrderedProducts(
                this.entireProducts,
                this.orderData.product_info,
                this.orderData.appliedProductPromotions
              ),
            ]
          : this.orderData.group_product_info.map((g) =>
              orderHelpers.refineOrderedProducts(
                this.entireProducts,
                g.product_info,
                this.orderData.appliedProductPromotions
              )
            ),
        packNames: !this.isBundle
          ? [this.orderData.mypack_name]
          : this.orderData.group_product_info.map((g) => g.mypack_name),
      };
    },
    totalPaymentInfo() {
      return {
        totalPrice: thousandSeparator(this.orderData.total_price),
        totalPv: thousandSeparator(this.orderData.total_pv),
        totalBv: thousandSeparator(this.orderData.total_bv),
        totalDiscount: 0,
        orderPrice: thousandSeparator(
          this.orderData.total_price - this.deliveryFee - this.packagingFee
        ),
        deliveryFee: thousandSeparator(this.deliveryFee),
        packagingFee: thousandSeparator(this.packagingFee),
      };
    },
    packsSummary() {
      return !this.isBundle
        ? [
            {
              packName: this.orderData.mypack_name,
              amounts: {
                price: thousandSeparator(this.orderData.total_price),
                pv: thousandSeparator(this.orderData.total_pv),
                bv: thousandSeparator(this.orderData.total_bv),
              },
            },
          ]
        : this.orderData.group_product_info.map((info) => {
            return {
              packName: info.mypack_name,
              amounts: {
                price: thousandSeparator(info.total_price),
                pv: thousandSeparator(info.total_pv),
                bv: thousandSeparator(info.total_bv),
              },
            };
          });
    },
  },
  methods: {
    async updateCartInfo(event) {
      log("UpdateCartInfo", event);

      let occPaymentModeCode = "";

      if (event.paymentMethod === PAYMENT_METHODS.NORMAL) {
        if (event.otherPaymentMethod === NORMAL_PAYMENT_METHODS.TRANSFER) {
          occPaymentModeCode = "directdebit";
        } else if (
          event.otherPaymentMethod === NORMAL_PAYMENT_METHODS.CREDIT_CARD
        ) {
          occPaymentModeCode = "creditcard";
        }
      } else if (event.paymentMethod === PAYMENT_METHODS.AMWAY_PAY) {
        if (event.amwayPayMethod === AMWAY_PAY_METHODS.ACCOUNT) {
          occPaymentModeCode = "amwaypayaccount";
        } else if (event.amwayPayMethod === AMWAY_PAY_METHODS.CARD) {
          occPaymentModeCode = "amwaypaycard";
        } else if (event.amwayPayMethod === AMWAY_PAY_METHODS.QUICK_ACCOUNT) {
          occPaymentModeCode = "quickaccount";
        }
      }
      if (occPaymentModeCode === "") {
        return;
      }

      await this.changePaymentMethod(
        occPaymentModeCode,
        this.isBundle ? "Y" : "N"
      );
    },
    async init() {
      const clientKey = await orderApi.getAmwayPayClientKey();

      // await this.$store.dispatch("resetOrderInfo")

      if (this.orderData.cfm_kind === PICKUP_METHODS.VCALL) {
        this.$store.commit("order/fixReceiveMethod", PICKUP_METHODS.DELIVERY);
      } else {
        this.$store.commit("order/fixReceiveMethod", PICKUP_METHODS.PICK_UP);
      }

      this.$store.commit("account/accountAmount", this.orderData.total_price);
      this.$store.commit(
        "creditcard/creditCardAmount",
        this.orderData.total_price
      );

      this.$store.commit("delivery/updateDeliveryInfo", {
        id: this.orderData.abo_info.defaultAddress.id,
        name: this.orderData.abo_info.defaultAddress.name,
        cellphone: this.orderData.abo_info.defaultAddress.cellphone,
        postalCode: this.orderData.abo_info.defaultAddress.postalCode,
        formattedAddress:
          this.orderData.abo_info.defaultAddress.formattedAddress,
        message: "",
      });

      this.$store.commit(
        "amwaypay/updateAmwayPayAccountClientKey",
        clientKey.amwayPayAccount.clientKey
      );
      this.$store.commit(
        "amwaypay/updateAmwayPayCardClientKey",
        clientKey.amwayPayCard.clientKey
      );
    },
    async fetchPaymentConfig() {
      const params = {
        payment_mode: BILLING_PAYMENT_MODE.QUICK_ACCOUNT,
        payment_type: QUICK_ACCOUNT_PAYMENT_TYPE.NORMAL,
        cart_code: this.orderData.code,
      };
      const result = await orderApi.getPaymentConfig(params);
      console.log("result", result);

      if (result.error) {
        return;
      }
      return result;
    },
    storeDeliveryInfo(event) {
      this.orderData.abo_info.defaultAddress = { ...event };
      this.$store.commit("delivery/updateDeliveryInfo", event);
    },
    storeReceiptInfo(event) {
      this.cashReceipt = { ...event };
      this.$store.commit("receipt/updateApplying", event.applying);
      this.$store.commit("receipt/updateRegType", event.cashReceiptRegType);
      this.$store.commit("receipt/updateRegTypeNum", event.regTypeNum);
    },
    isProcessableOrder() {
      console.log(this.isTossTermsRequired);
      console.log(this.allTerms);
      return this.isTossTermsRequired
        ? !this.allTerms.includes(false)
        : !this.allTerms.slice(0, 2).includes(false);
    },
    async onClickOrder() {
      // 필수약관 동의 체크
      if (!this.isProcessableOrder()) {
        let message = "필수약관에 모두 동의하셔야 주문을 진행할 수 있습니다.";

        await this.$refs.refAlert.openWithMessage(message);
        return false;
      }

      try {
        await this.validateForm();
      } catch (error) {
        console.error(error);

        await this.$refs.refAlert.openWithMessage(error.message);
        return false;
      }

      if (this.currentOrderMode === PAYMENT_METHODS.NORMAL) {
        const { result, error } = await this.handleNormalOrder();

        if (error) {
          await this.$refs.refAlert.openWithMessage(error);
          return false;
        }

        if (!result) {
          await this.$refs.refAlert.openWithMessage("결제에 실패하였습니다.");
          return false;
        }

        const orderResult = {
          order_no: result.order_key,
          order_date: result.reg_date,
          total_bv: result.total_bv,
          total_pv: result.total_pv,
          address: result.address,
          paymentMethod: this.currentOtherPayMethod,
          ...this.orderData,
          orders: result.orders,
        };

        if (this.currentReceiveMethod === PICKUP_METHODS.DELIVERY) {
          orderResult.delivery = {
            name: this.storedDeliveryInfo.recv_name,
            cellphone: this.storedDeliveryInfo.recv_phone,
            address: this.storedDeliveryInfo.addr,
            postalCode: this.storedDeliveryInfo.zip,
          };
        }

        this.$router.push({
          name: "order-complete",
          params: {
            orderResult,
          },
        });
      } else if (this.currentOrderMode === PAYMENT_METHODS.AMWAY_PAY) {
        let result = {};
        // 퀵계좌이체
        if(this.currentAmwayPayMethod == AMWAY_PAY_METHODS.QUICK_ACCOUNT) {
          result = await this.handleQuickAccountOrder();
        } 
        // AmwayPay
        else {
          result = await this.handleAmwayPayOrder();
        }

        if (result.error) {
          log("AmwayPay::Fail::", result.error);
          const message = result.error.message
            ? result.error.message
            : result.error
            ? result.error
            : "암웨이페이 결제에 실패하였습니다.";
          await this.$refs.refAlert.openWithMessage(
            message ? message : "[[암웨이페이 결제에 실패하였습니다.]]"
          );
          return false;
        }
        const orderResult = {
          order_no: result.order_key,
          order_date: result.reg_date,
          total_bv: result.total_bv,
          total_pv: result.total_pv,
          address: result.address,
          paymentMethod: this.currentAmwayPayMethod,
          ...this.orderData,
          orders: result.orders,
        };

        if (this.currentReceiveMethod === PICKUP_METHODS.DELIVERY) {
          orderResult.delivery = {
            name: this.storedDeliveryInfo.recv_name,
            cellphone: this.storedDeliveryInfo.recv_phone,
            address: this.storedDeliveryInfo.addr,
            postalCode: this.storedDeliveryInfo.zip,
          };
        }

        this.$router.push({
          name: "order-complete",
          params: {
            orderResult,
          },
        });
      } else {
        await this.$refs.refAlert.openWithMessage("결제수단을 선택해주세요.");
        return false;
      }
    },
    async validateForm() {
      // 배송방법 검증
      // 택배
      if (this.currentReceiveMethod === PICKUP_METHODS.DELIVERY) {
        if (this.storedDeliveryInfo.id === "") {
          const addressUrl = `${process.env.HYBRIS_SHIP_URL}`;
          await this.$refs.refAlert.openUrlOnConfirm(
            addressUrl,
            "암웨이 홈페이지에 등록된 기본배송지가 없습니다.\n 암웨이 홈페이지에서 기본배송지를 등록후 다시 주문해주세요."
          );
        }
      }

      if (this.currentReceiveMethod === PICKUP_METHODS.PICK_UP) {
        if (this.pickUpAboPhone === "" || this.pickUpAboPhone.length <= 3) {
          // throw new Error("픽업하시는 분의 전화번호를 입력해주세요.")
          const addressUrl = `${process.env.HYBRIS_SHIP_URL}`;
          await this.$refs.refAlert.openUrlOnConfirm(
            addressUrl,
            "암웨이 홈페이지에 등록된 기본배송지가 없습니다.\n 암웨이 홈페이지에서 기본배송지를 등록후 다시 주문해주세요."
          );
        }
      }

      // 결제 폼 검증
      // 다른결제수단
      if (this.currentOrderMode === PAYMENT_METHODS.NORMAL) {
        // 계좌이체
        if (this.currentOtherPayMethod === NORMAL_PAYMENT_METHODS.TRANSFER) {
          if (!this.accountPassword.validated) {
            throw new Error("자동이체 비밀번호를 확인해 주세요.");
          }
        } else {
          // 신용카드
          if (this.creditCardInfo.cardCompanyCode === "") {
            throw new Error("신용카드를 선택해 주세요.");
          }

          if (this.creditCardInfo.cardNumber.length < 15) {
            throw new Error("카드번호를 정확히 입력해 주세요.");
          }

          if (this.creditCardInfo.validToYear.length < 2) {
            throw new Error("카드유효기간을 설정해 주세요.");
          }

          if (this.creditCardInfo.validToMonth.length < 2) {
            throw new Error("카드유효기간을 설정해 주세요.");
          }

          if (this.creditCardInfo.cardAuthNumber.length < 6) {
            throw new Error("생년월일을 6자로 입력해 주세요.");
          }

          if (this.creditCardInfo.cardPassword.length < 2) {
            throw new Error("카드비밀번호 앞 2자리를 입력해 주세요.");
          }
        }
      } else if (this.currentOrderMode === PAYMENT_METHODS.AMWAY_PAY) {
        // 암웨이페이

        // 계좌
        if (this.currentAmwayPayMethod === AMWAY_PAY_METHODS.ACCOUNT) {
          log(
            "Order::Mounted::AccountClientKey::",
            this.amwayPayAccountClientKey
          );
          if (this.amwayPayAccount.accountNumber === "") {
            throw new Error("A Pay 계좌를 선택해 주세요.");
          }
        } else if (this.currentAmwayPayMethod === AMWAY_PAY_METHODS.CARD) {
          // 카드
          log("Order::Mounted::CardClientKey::", this.amwayPayCardClientKey);
          if (this.amwayPayCard.cardNumber === "") {
            throw new Error("A Pay 카드를 선택해 주세요.");
          }
        } else if (this.currentAmwayPayMethod === AMWAY_PAY_METHODS.QUICK_ACCOUNT) {
          // 퀵계좌이체 EMPTY
        } else {
          throw new Error("A Pay 결제수단이 선택되지 않았습니다.");
        }
      } else {
        throw new Error("결제 수단이 선택되지 않았습니다.");
      }
    },
    // 일반 결제 처리
    async handleNormalOrder() {
      let params;
      if (this.currentOtherPayMethod === NORMAL_PAYMENT_METHODS.TRANSFER) {
        params = this.getAutoWithdrawParams();
      } else {
        params = this.getCreditCardParams();
      }
      if (this.currentReceiveMethod === PICKUP_METHODS.DELIVERY) {
        params.delivery_info = this.storedDeliveryInfo;
        params.abo_phone = this.storedDeliveryInfo.recv_phone;
      } else {
        params.abo_phone = this.pickUpAboPhone;
      }

      params.purchase_type = this.localPurchaseType;

      // 그룹 오더 여부에 따라 분기 처리
      if (this.isBundle) {
        let orderInfos = this.orderData.group_product_info.map((item) => {
          return {
            req_no: item.req_no,
            code: item.code,
          };
        });
        Object.assign(params, {
          search_type: "P",
          req_no: orderInfos[0].req_no,
          code: orderInfos[0].code,
          group: "Y",
          abo_name: this.orderData.abo_info.name,
          sub_order: orderInfos.slice(1),
        });
      } else {
        Object.assign(params, {
          search_type: "P",
          req_no: this.orderData.reqNo,
          code: this.orderData.code,
          abo_name: this.orderData.abo_info.name,
        });
      }

      return orderApi.doOrder(params);
    },
    getDateTime() {
      const today = new Date();
      let month = today.getMonth() + 1;
      let date = today.getDate();
      let hour = today.getHours();
      let minutes = today.getMinutes();
      let seconds = today.getSeconds();

      return `${month < 10 ? "0" + month : month}${
        date < 10 ? "0" + date : date
      }${hour < 10 ? "0" + hour : hour}${
        minutes < 10 ? "0" + minutes : minutes
      }${seconds < 10 ? "0" + seconds : seconds}`;
    },
    async handleAmwayPayOrder() {
      if (this.ssoToken === "") {
        let tokenResponse = await auth.getSsoToken();
        console.log("Store::ssoToken", ssoToken);
        if (tokenResponse !== undefined && typeof tokenResponse === "string") {
          this.$store.commit("updateSsoToken", tokenResponse);
        }
      }

      const today = this.getDateTime();
      const cartId = this.orderData.code;

      let clientKey =
        this.currentAmwayPayMethod === AMWAY_PAY_METHODS.ACCOUNT
          ? this.amwayPayAccountClientKey
          : this.amwayPayCardClientKey;
      let customerId =
        this.currentAmwayPayMethod === AMWAY_PAY_METHODS.ACCOUNT
          ? this.amwayPayAccount.customerId
          : this.amwayPayCard.customerId;
      let ssoToken = this.ssoToken;
      let paymentMode =
        this.currentAmwayPayMethod === AMWAY_PAY_METHODS.ACCOUNT
          ? "amwaypayaccount"
          : "amwaypaycard";
      let storeId =
        this.currentAmwayPayMethod === AMWAY_PAY_METHODS.ACCOUNT
          ? this.amwayPayAccountStoreId
          : this.amwayPayCardStoreId;
      let methodId =
        this.currentAmwayPayMethod === AMWAY_PAY_METHODS.ACCOUNT
          ? this.amwayPayAccount.id
          : this.amwayPayCard.id;

      let redirectUrl = `${process.env.OCC_HOST}/api/v2/amwaykorea/amwaypay/access-token/${paymentMode}?ssoToken=${ssoToken}`;
      log("RedirectURL::", redirectUrl);

      log("HandleAmwayPayOrder::", clientKey, customerId, ssoToken);

      let connectPay = ConnectPay(clientKey, customerId, {
        redirectUrl: redirectUrl,
      });

      let tossParams = {
        orderId: `${today}${cartId.replaceAll("-", "")}`,
        orderName:
          this.orderedProductsData.orderedProducts[0][0].item_name +
          ` 외 ${this.orderedProductsData.orderedProducts[0].length - 1}건`,
        amount: this.orderData.total_price,
        methodId: methodId,
        cardInstallmentPlan: this.amwayPayInstallmentPlan,
      };

      console.log(tossParams);

      const orderResult = await connectPay
        .requestPayment(tossParams)
        .then((response) => {
          log("TossPayment::", response);
          return this.occRequestPayment(
            paymentMode,
            response.paymentKey,
            response.orderId,
            response.amount,
            storeId,
            cartId,
            this.amwayPayInstallmentPlan
          );
        })
        .catch((error) => {
          log("TossPayment::Error::", error);
          if (error.code === "USER_CANCEL") {
            log("TossPayment::Error::", "고객 취소");
          } else {
            log("TossPayment::Error::");
            console.error(error);
            console.error(error.message);
            if (!error.message) {
              error.message =
                "결제가 정상적으로 진행되지 못하였습니다. \n 새로 고침 후 다시 진행 부탁드립니다.";
            }
          }
          return { error };
        });

      log("HandleAmwayPayOrder::", orderResult);

      return orderResult;
    },
    async handleQuickAccountOrder() {

      const data = await this.fetchPaymentConfig();

      var tossPayments = TossPayments(data.CLIENT_KEY);

      var requestPaymentParam = {
        amount: this.orderData.total_price,
        orderId: data.OID,
        orderName: this.orderedProductsData.orderedProducts[0][0].item_name +
          ` 외 ${this.orderedProductsData.orderedProducts[0].length - 1}건`,
        customerName: data.CUSTOMER_NAME,
      }

      const cartId = this.orderData.code;
      const paymentMode = "quickaccount"
      const storeId = "amwayquick"

      var successFunction = (response) => {
          return this.occRequestPayment(
            paymentMode,
            response.paymentKey,
            response.orderId,
            response.amount,
            storeId,
            cartId,
            ""
          );
      }

      var catchFunction = (error) => {
        log("TossPayment::Error::", error);
        if (error.code === "PAY_PROCESS_CANCELED") {
          log("TossPayment::Error::", "사용자가 결제를 취소하였습니다.");
        } else {
          log("TossPayment::Error::");
          console.error(error);
          console.error(error.message);
          if (!error.message) {
            error.message =
              "결제가 정상적으로 진행되지 못하였습니다. \n 새로 고침 후 다시 진행 부탁드립니다.";
          }
        }
        return { error };
      };

      // Desktop
      if (!this.isMobile) {
        const orderResult = await tossPayments
          .requestPayment("계좌이체", requestPaymentParam)
          .then(successFunction)
          .catch(catchFunction);
          
        log("handleQuickAccountOrder::", orderResult);

        return orderResult;
      }
      // Mobile
      else if (this.isMobile) {

        // store 저장
        const stateCopy = { ...this.$store.state };
        delete stateCopy.appReadyState; // appReadyState 제외
        sessionStorage.setItem("save-vuex", JSON.stringify(stateCopy));
        sessionStorage.setItem("save-data", JSON.stringify(this.$data));
        sessionStorage.setItem("save-props", JSON.stringify(this.$props));

        log("sessionStorage vuex :: " + JSON.stringify(stateCopy));
        log("sessionStorage data :: " + JSON.stringify(this.$data));
        log("sessionStorage props :: " + JSON.stringify(this.$props));

        var urlPrefix =
          window.location.protocol +
          "//" +
          window.location.hostname +
          (!!window.location.port && window.location.port != "80"
            ? ":" + window.location.port
            : "");
        (requestPaymentParam.successUrl =
          urlPrefix + "/order"),
          (requestPaymentParam.failUrl =
            urlPrefix + "/order");
            
          const orderResult = await tossPayments
            .requestPayment("계좌이체", requestPaymentParam)
            .catch(catchFunction);
            
        return orderResult;
      }
    },
    getAutoWithdrawParams() {
      const result = {
        payment_info: this.accountPaymentInfo,
      };

      if (this.cashReceipt.applying !== "") {
        result.receipt_info = {
          receiptType: "CASH",
          receiptIssuanceType: this.storedReceiptInfo.cashReceiptCategory,
          receiptNumberType: this.storedReceiptInfo.cashReceiptRegType,
          receiptIssuanceNumber: this.storedReceiptInfo.regTypeNum,
        };
      }

      return result;
    },
    getCreditCardParams() {
      return {
        payment_info: this.creditCardInfo,
      };
    },
    ...mapActions({
      getAmwayPayMethods: "amwaypay/getAmwayPayMethods",
    }),
    async occRequestPayment(
      paymentMode,
      paymentKey,
      orderId,
      amount,
      storeId,
      cartId,
      installmentPlan = 0
    ) {
      const apayData = {
        paymentModeCode: paymentMode,
      };

      if (paymentMode === "amwaypayaccount") {
        apayData.capturePaymentInfoData = {
          amwayPayAccountPaymentInfo: {
            orderId: orderId,
            paymentKey: paymentKey,
            amount: amount,
            storeId: storeId,
            paymentMode: {
              code: paymentMode,
            },
          },
        };
      } else if (paymentMode === "amwaypaycard") {
        apayData.capturePaymentInfoData = {
          amwayPayCardPaymentInfo: {
            orderId: orderId,
            paymentKey: paymentKey,
            amount: amount,
            installmentPlan: installmentPlan,
            storeId: storeId,
            paymentMode: {
              code: paymentMode,
            },
          },
        };
      } else if (paymentMode === "quickaccount") {
        apayData.capturePaymentInfoData = {
          quickAccountPaymentInfo: {
            orderId: orderId,
            paymentKey: paymentKey,
            amount: amount,
            storeId: storeId,
            paymentMode: {
              code: paymentMode,
            },
          },
        };
      }

      const postData = {
        apayData: apayData,
        aboId: this.orderData.abo_info.uid,
        cartId: cartId,
        purchaseType: this.localPurchaseType,
      };

      if (paymentMode === "amwaypayaccount" || paymentMode === "quickaccount") {
        if (this.cashReceipt.applying !== "") {
          postData.receiptInfo = {
            receiptType: "CASH",
            receiptIssuanceType: this.storedReceiptInfo.cashReceiptCategory,
            receiptNumberType: this.storedReceiptInfo.cashReceiptRegType,
            receiptIssuanceNumber: this.storedReceiptInfo.regTypeNum,
          };
        }
      }

      if (this.currentReceiveMethod === PICKUP_METHODS.DELIVERY) {
        postData.deliveryInfo = this.storedDeliveryInfo;
        postData.aboPhone = this.storedDeliveryInfo.recv_phone;
      } else {
        postData.aboPhone = this.pickUpAboPhone;
      }

      // 그룹 오더 여부에 따라 분기 처리
      if (this.isBundle) {
        let orderInfos = this.orderData.group_product_info.map((item) => {
          return {
            requestId: item.req_no,
            code: item.code,
          };
        });
        postData.mpnOrderInfo = {
          requestId: orderInfos[0].requestId,
          code: orderInfos[0].code,
          group: true,
          aboName: this.orderData.abo_info.name,
          subOrder: orderInfos.slice(1),
        };
      } else {
        postData.mpnOrderInfo = {
          requestId: this.orderData.reqNo,
          code: this.orderData.code,
          group: false,
          aboName: this.orderData.abo_info.name,
        };
      }

      const result = orderApi.requestPayment(postData);
      log("HandleAmwayPayOrder::", result);

      return result;
    },
    changeTermsPopup(event) {
      this.displayTermsPopup = event.display;
      this.displayTermsIndex = event.index;
    },
    async changePaymentMethod(occPaymentModeCode, groupOrder) {
      try {
        const result = await orderApi.changePaymentMethod(
          this.orderData.code,
          occPaymentModeCode,
          groupOrder
        );

        this.orderData.appliedProductPromotions =
          result.appliedProductPromotions;
        this.orderData.appliedOrderPromotions = result.appliedOrderPromotions;

        this.orderData.total_bv = result.total_bv;
        this.orderData.total_price = result.total_price;
        this.orderData.total_pv = result.total_pv;

        this._.merge(
          this.orderData.group_product_info,
          result.group_product_info
        );
      } catch (e) {}
    },
  },
  data() {
    return {
      isMobile: "ontouchstart" in document.documentElement,
      paymentConfig: {},
      localOrderInfo: this.orderInfo ? { ...this.orderInfo } : null,
      localAmwayPayMethods: this.amwayPayMethods ? { ...this.amwayPayMethods } : null,
      localPurchaseType: this.purchaseType || '',
      customerInsuranceToolTip: false,
      pageTitle: "주문/결제",
      orderData: { ...this.orderInfo },
      cashReceipt: {
        applying: "",
        cashReceiptCategory: "INCOME_DEDUCTION",
        cashReceiptRegType: "",
        regTypeNum: "",
      },
      displayTermsPopup: false,
      displayTermsIndex: 0,
    };
  },
  async created() {
    log("Order::Created");

    // success
    const paymentKey = this.$route.query.paymentKey;
    const amount = this.$route.query.amount;
    const orderId = this.$route.query.orderId;

    // fail
    const code = this.$route.query.code;
    const message = this.$route.query.message;
    
    log("Order::Created::paymentKey " + paymentKey);
    log("Order::Created::amount " + amount);
    log("Order::Created::orderId " + orderId);
    log("Order::Created::code " + code);
    log("Order::Created::message " + message);

    if ((paymentKey && amount && orderId) || (code && message && orderId)) {
      const savedState = sessionStorage.getItem("save-vuex");
      if (savedState) {
        const parsedState = JSON.parse(savedState);

        // 현재 store의 appReadyState 유지 (백업에서 가져오지 않음)
        const currentAppReadyState = this.$store.state.appReadyState;
        this.$store.replaceState({
          ...parsedState,
          appReadyState: currentAppReadyState, // 유지
        });
        sessionStorage.removeItem("save-vuex");
      }
      const savedData = sessionStorage.getItem("save-data");
      if (savedData) {
        Object.assign(this.$data, JSON.parse(savedData));
        if(this.localOrderInfo) {
          this.orderData =  { ...this.localOrderInfo };
        }
        sessionStorage.removeItem("save-data");
      }

      const savedProps = sessionStorage.getItem("save-props");
      log("savedProps", savedProps);
      if (savedProps) {
        const parsedProps = JSON.parse(savedProps);
        if(parsedProps.orderInfo) {
          this.localOrderInfo = parsedProps.orderInfo;
          this.orderData =  { ...this.localOrderInfo };
        }
        if(parsedProps.amwayPayMethods) {
          this.localAmwayPayMethods = parsedProps.amwayPayMethods;
        }
        if(parsedProps.purchaseType) {
          this.localPurchaseType = parsedProps.purchaseType;
        }
        sessionStorage.removeItem("save-props");
      }

      // 잘못된 접근이거나 정상적이지 않은 상태이면
      if (!this.localOrderInfo || !this.localAmwayPayMethods) {
        log("localOrderInfo :: ", this.localOrderInfo);
        log("localAmwayPayMethods :: ", this.localAmwayPayMethods);
        log("props is empty");
        await this.$router.push("/");
      }
    } else {
      // 잘못된 접근이거나 정상적이지 않은 상태이면
      if (!this.orderInfo || !this.amwayPayMethods) {
        log("props is empty");
        await this.$router.push("/");
      }
      await this.init();
    }
  },
  async mounted() {
    log("Order::Mounted");

    // load toss sdk 
    const script = document.createElement("script");
    script.src = "https://js.tosspayments.com/v1/payment";
    script.onload = () => {
      log("tosspayments::load js");
    };
    document.head.appendChild(script);

    await this.$nextTick();

    // success
    const paymentKey = this.$route.query.paymentKey;
    const amount = this.$route.query.amount;
    const orderId = this.$route.query.orderId;

    // fail
    const code = this.$route.query.code;
    const message = this.$route.query.message;

    // url 변경
    if ((paymentKey && amount && orderId) || (code && message && orderId)) {
      this.$router.replace(this.$route.path);
    }

    // 퀵계좌이체 결과 리턴
    if (paymentKey && amount && orderId) {
      // 결제 수행
      const cartId = this.orderData.code;
      const paymentMode = "quickaccount"
      const storeId = "amwayquick"

      const result = await this.occRequestPayment(
        paymentMode,
        paymentKey,
        orderId,
        amount,
        storeId,
        cartId,
        ""
      );

      if (result.error) {
        log("AmwayPay::Fail::", result.error);
        const message = result.error.message
          ? result.error.message
          : result.error
          ? result.error
          : "암웨이페이 결제에 실패하였습니다.";
        await this.$refs.refAlert.openWithMessage(
          message ? message : "[[암웨이페이 결제에 실패하였습니다.]]"
        );
        return false;
      }
      const orderResult = {
        order_no: result.order_key,
        order_date: result.reg_date,
        total_bv: result.total_bv,
        total_pv: result.total_pv,
        address: result.address,
        paymentMethod: this.currentAmwayPayMethod,
        ...this.orderData,
        orders: result.orders,
      };

      if (this.currentReceiveMethod === PICKUP_METHODS.DELIVERY) {
        orderResult.delivery = {
          name: this.storedDeliveryInfo.recv_name,
          cellphone: this.storedDeliveryInfo.recv_phone,
          address: this.storedDeliveryInfo.addr,
          postalCode: this.storedDeliveryInfo.zip,
        };
      }

      this.$router.push({
        name: "order-complete",
        params: {
          orderResult,
        },
      });
    } else if(code && message) {
      if (this.$refs.refAlert) {
        await this.$refs.refAlert.openWithMessage(message);
      }
    }
  },  
};
</script>


<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/order/main/Order.vue